import { render, staticRenderFns } from "./charge-goods-cost.vue?vue&type=template&id=5c378661"
import script from "./charge-goods-cost.vue?vue&type=script&lang=js"
export * from "./charge-goods-cost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports